import { IGoodReceive } from '@/interfaces/goodReceive';
import { formatThaiDate, formatNumber } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  data?: IGoodReceive;
}

const TemplateReceiveOrderInfoItem = ({ data }: IProps) => {
  return (
    <>
      <div className="flex w-full text-xs mt-5">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={2}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
          }}
        >
          <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={20}
            >
              <strong>#</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>ITEM NO.</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>DESCRIPTION</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>LOT NO.</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={80}
            >
              <strong>EXPIRATION DATE</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={40}
            >
              <strong>Total Qty</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={40}
            >
              <strong>Package size</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={40}
            >
              <strong>Total Unit</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={40}
            >
              <strong>UOM</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={60}
            >
              <strong>BU</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>Remark</strong>
            </td>
          </tr>
          {data?.goodReceiveItems
            .filter(g => g.quantity > 0)
            ?.map((i, idx) => {
              return (
                <tr key={i.id}>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {idx + 1}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {i.productCode}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                    }}
                  >
                    {i.productName}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {i.lotNumber}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {formatThaiDate(i.expiredDate)}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {formatNumber(i.quantity * i.conversion)}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {formatNumber(i.conversion)}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {formatNumber(i.quantity)}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                  >
                    {i.packageUnitId}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'right',
                    }}
                  >
                    {data?.inbound?.businessUnit?.name}
                  </td>
                  <td
                    style={{
                      border: '1px solid black',
                      textAlign: 'right',
                    }}
                  ></td>
                </tr>
              );
            })}
        </table>
      </div>
    </>
  );
};

export default TemplateReceiveOrderInfoItem;
